import PropTypes from "prop-types";
import React from "react";
import { Card, CardHeader } from "shards-react";
import { printType } from "../layout/user/type";

const UserDetails = ({ userDetails }) => {
  //console.log(userDetails);
  return (
    <Card small className="mb-4 pt-3">
      <CardHeader className="border-bottom text-center">
        <div className="mb-3 mx-auto">
          <img
            className="rounded-circle"
            src={require("../../images/avatars/avatar.png")}
            alt={userDetails.username}
            width="110"
          />
        </div>
        <h4 className="mb-0">{userDetails.username}</h4>
        <span className="text-muted d-block mb-2">
          {printType(userDetails)}
        </span>
      </CardHeader>
    </Card>
  );
};

UserDetails.propTypes = {
  /**
   * The user details object.
   */
  userDetails: PropTypes.object,
};

UserDetails.defaultProps = {
  userDetails: {
    name: "Sierra Brooks",
    avatar: require("../../images/avatars/avatar.png"),
    jobTitle: "Project Manager",
    performanceReportTitle: "Workload",
    performanceReportValue: 74,
    metaTitle: "Description",
    metaValue:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio eaque, quidem, commodi soluta qui quae minima obcaecati quod dolorum sint alias, possimus illum assumenda eligendi cumque?",
  },
};

export default UserDetails;
